import React from "react";
import { Box, Container, Typography, Grid } from "@mui/material";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";

const points = [
  {
    title: "Instant App Unlocking",
    body: "Locate a scooter nearby, scan its QR code, and unlock your vehicle in seconds without keyless friction.",
  },
  {
    title: "Swappable Battery Network",
    body: "Never worry about range. Swap your battery in under 60 seconds at battery hubs spread across the city.",
  },
  {
    title: "All-Inclusive Maintenance",
    body: "Zero maintenance costs for you. RideX City manages regular servicing and breakdown support end-to-end.",
  },
  {
    title: "Engineered for City Mobility",
    body: "High-performance electric power built for main city roads, flyovers, and daily office commuting.",
  },
];

export default function WhyChooseUs() {
  return (
    <Box id="why-choose-us" component="section" sx={{ py: { xs: 8, md: 12 }, bgcolor: "background.paper" }}>
      <Container maxWidth="lg">
        <Grid container spacing={{ xs: 4, md: 6 }} alignItems="flex-start">
          <Grid item xs={12} md={5}>
            <Box
              sx={{
                display: "inline-block",
                px: 2,
                py: 0.6,
                borderRadius: "20px",
                bgcolor: "rgba(27, 78, 216, 0.08)",
                color: "primary.main",
                fontSize: 12.5,
                fontWeight: 700,
                letterSpacing: "0.06em",
                textTransform: "uppercase",
                mb: 1.5,
              }}
            >
              WHY RIDEX CITY
            </Box>
            <Typography
              variant="h3"
              sx={{
                fontFamily: "'Space Grotesk', sans-serif",
                fontSize: { xs: 30, md: 38 },
                fontWeight: 700,
                color: "text.primary",
                mb: 2,
                letterSpacing: "-0.02em",
              }}
            >
              Smart City Rides.{" "}
              <Box component="span" sx={{ color: "primary.main" }}>
                Zero Hassle.
              </Box>
            </Typography>
            <Typography sx={{ color: "text.secondary", fontSize: 16, lineHeight: 1.7 }}>
              RideX City provides premium, high-performance electric scooter rentals designed to make urban commuting fast, affordable, and eco-friendly.
            </Typography>
          </Grid>

          <Grid item xs={12} md={7}>
            <Grid container spacing={2.5}>
              {points.map((point) => (
                <Grid item xs={12} sm={6} key={point.title}>
                  <Box
                    sx={{
                      bgcolor: "background.default",
                      borderRadius: "16px",
                      p: 3,
                      height: "100%",
                      border: "1px solid",
                      borderColor: "divider",
                      transition: "transform 0.25s ease, box-shadow 0.25s ease",
                      "&:hover": {
                        transform: "translateY(-3px)",
                        borderColor: "secondary.main",
                        boxShadow: "0 12px 28px -12px rgba(114, 191, 32, 0.2)",
                      },
                    }}
                  >
                    <Box
                      sx={{
                        width: 40,
                        height: 40,
                        borderRadius: "10px",
                        bgcolor: "rgba(114, 191, 32, 0.15)",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        mb: 2,
                      }}
                    >
                      <CheckCircleIcon sx={{ color: "secondary.dark", fontSize: 22 }} />
                    </Box>

                    <Typography
                      variant="h6"
                      sx={{
                        fontFamily: "'Space Grotesk', sans-serif",
                        fontSize: 16.5,
                        fontWeight: 700,
                        color: "text.primary",
                        mb: 1,
                      }}
                    >
                      {point.title}
                    </Typography>
                    <Typography sx={{ fontSize: 13.5, color: "text.secondary", lineHeight: 1.6 }}>
                      {point.body}
                    </Typography>
                  </Box>
                </Grid>
              ))}
            </Grid>
          </Grid>
        </Grid>
      </Container>
    </Box>
  );
}
